module.exports = __webpack_public_path__ + "static/media/isdoctorplan-general1@2x.25e0938a.png";